import React from "react";
import { Link } from "react-router-dom";
import logo1 from "../LandingPage/img/logo1.png";
import styled from "styled-components";
import './css/own.css'
function Header() {
  return (
    <>
      <HeaderCss>
        {/* 🔹 Main Header Section */}
        <section className="bg-white shadow-md">
          <div className="flex flex-col md:flex-row items-center justify-center text-center md:justify-between py-3 px-4 md:px-10 space-y-3 md:space-y-0">
            {/* Logo Section */}
            <div className="flex justify-center md:justify-start w-full md:w-auto">
              <Link to="/">
                <img
                  src={logo1}
                  alt="AICEE Logo"
                  className="w-24 md:w-28 lg:w-24 object-contain"
                />
              </Link>
            </div>

            {/* Title Section */}
            <div className="w-full md:flex-1 text-center">
              <h1 className="text-[1.3rem] md:text-[1.8rem] font-bold text-[#04124f] leading-tight">
                ALL INDIA COMBINED ENTRANCE EXAMINATION
              </h1>
              <h4 className="text-[#EB493A] font-semibold text-lg md:text-xl">
                AICEE - 2026
              </h4>
            </div>

            {/* Right Placeholder (for symmetry) */}
            <div className="hidden md:block w-24 lg:w-36"></div>
          </div>

          {/* 🔹 Marquee Bar (Now at Bottom) */}
          <div className="bg-[#04124f] text-white py-1 text-sm">
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="5"
              className="tracking-wide"
            >
              🚀 For Better user friendly experience use Laptop /Desktop or PC while filling out the application .
            </marquee>
          </div>
        </section>
      </HeaderCss>
    </>
  );
}

const HeaderCss = styled.main`
  .landingLogo {
    transition: transform 0.3s ease;
  }
  .landingLogo:hover {
    transform: scale(1.05);
  }
  marquee {
    font-weight: 500;
    letter-spacing: 0.5px;
  }
`;

export default Header;
